import { createApp } from "vue";
import store from "../../common/js/store";
import registerServiceWorker from "./serviceWorkerRegistration";

// Global components import
import PageHeader from "../../common/js/components/PageHeader.vue";
import FilterMenuAnchorLinks from "../../common/js/components/FilterMenuAnchorLinks.vue";
import BottomBar from "../../common/js/components/BottomBar.vue";
import HorizontalNavWithAnchorLinks from "../../common/js/components/HorizontalNavWithAnchorLinks.vue";
import VerticalProductsScrollMenu from "../../common/js/components/VerticalProductsScrollMenu.vue";
import SearchModal from "../../common/js/components/SearchModal.vue";
import ProductCardModal from "../../common/js/components/ProductCardModal.vue";
import Search from "../../common/js/components/Search.vue";
import CustomizationInit from "../../common/js/components/CustomizationInit.vue";
import GenericModal from "../../common/js/components/GenericModal.vue";
import HongsLogo from "../../common/js/components/HongsLogo.vue";
import Loader from "../../common/js/components/Loader.vue";
import InitializeMenu from "../../common/js/components/InitializeMenu.vue";

const app = createApp({});
app.use(store);

// Global components registration
// @todo: similarly all other components registration currently inside Home.vue will move here and Home.vue will be discarded

app.component("page-header", PageHeader);
app.component("filter-menu-anchor-links", FilterMenuAnchorLinks);
app.component("horizontal-nav-with-anchor-links", HorizontalNavWithAnchorLinks);
app.component("vertical-products-scroll-menu", VerticalProductsScrollMenu);
app.component("bottom-bar", BottomBar);
app.component("search-modal", SearchModal);
app.component("product-card-modal", ProductCardModal);
app.component("search", Search);
app.component("customization-init", CustomizationInit);
app.component("generic-modal", GenericModal);
app.component("hongs-logo", HongsLogo);
app.component("loader", Loader);
app.component("initialize-menu", InitializeMenu);

app.mount("#themeDefaultMenu");

// @todo : uncomment this...

registerServiceWorker();

if (typeof window != "undefined") {
  window.onbeforeunload = () => {
    window.scrollTo(0, 0);
  };
}
